import { _MustMatchServerStrings, AccessGuids, ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, DgSelectionCheckBoxMode, DgSelectionMode, ErrorStrings, eSimApiPaths, msSize, OurColors } from 'src/app/core/consts';
import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, EMPTY, firstValueFrom, forkJoin, Observable, throwError } from 'rxjs';
import { CommConfigService } from 'src/app/core/services/utelize/system/communication/comm-config-service';
import { CommunicationComposeLimitResultDTO } from 'src/app/core/models/system/communication/communication-compose-limit-result.dto';
import { CommunicationCompositionDTO } from 'src/app/core/models/system/communication/communication-composition.dto';
import { CommunicationCompositionResultDTO } from 'src/app/core/models/system/communication/communication-composition-result.dto';
import { CommunicationDeliveryOutcomeDTO } from 'src/app/core/models/system/communication/communication-delivery-outcome.dto';
import { CommunicationDTO } from 'src/app/core/models/system/communication/communication.dto';
import { CommunicationService } from 'src/app/core/services/utelize/system/communication/communication-service';
import { CommunicationTemplateDTO } from 'src/app/core/models/system/communication/communication-template.dto';
import { CommunicationTemplateReplacements } from 'src/app/core/models/system/communication/communication-template-replacements';
import { CommunicationTemplatesDefaultsDTO } from 'src/app/core/models/system/communication/communication-templates-defaults.dto';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DatePipe } from '@angular/common';
import { DeliveryType, eUser, MessageType, MessageTypeText, SmsProviderOverride, TemplateModalAction } from 'src/app/core/enums';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DropdownService } from 'src/app/core/services/utelize/general/dropdown-service';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TemplateEmailModalFormComponent } from 'src/app/forms-modal/template-email-modal-form/template-email-modal-form.component';
import { TypesCommunicationService } from 'src/app/core/services/utelize/system/type/types-communication-service';
import { UserModalFormComponent } from '../../_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';
import { WidgetService } from 'src/app/core/services/utelize/general/widget-service';
import { WidgetSMSAllowanceDTO, WidgetSMSAllowanceDTO_EmptyObject } from 'src/app/core/models/system/widget/widget-sms-allowance.dto';

const apiPath             =environment.eSimApi+eSimApiPaths.Users + "/" + eSimApiPaths.UsersGetUsersForCompanyIncAssociates;
const exportFilenameSuffix="Compose-Recipients";
const popUpTitle          ="Recipient";

@Component({
  selector: 'app-communication-compose-modal-form',
  templateUrl: './communication-compose-modal-form.component.html',
  styleUrls: ['./communication-compose-modal-form.component.scss'],
  providers: [DatePipe, GridViewService]
})

export class CommunicationComposeModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() inline             : boolean=false;
  @Input() useTrmChannelParams: boolean=false;

  @Output() companyChanged  : EventEmitter<number            >=new EventEmitter<number            >();
  @Output() dataHasBeenSaved: EventEmitter<number | undefined>=new EventEmitter<number | undefined>();
  @Output() formCancelled   : EventEmitter<void              >=new EventEmitter<void              >();

  @ViewChild('communicationComposeModalForm', { static: false }) communicationComposeModalForm!: TemplateRef<void>;
  @ViewChild('completedModalForm',            { static: false }) completedModalForm!           : CompletedModalFormComponent;
  @ViewChild('emailTemplateModalForm',        { static: false }) emailTemplateModalForm!       : TemplateEmailModalFormComponent;
  @ViewChild('recipientsGrid',                { static: false }) recipientsGrid!               : GridViewComponent;
  @ViewChild('templateDropdown',              { static: false }) templateDropdown!             : ElementRef<HTMLElement>;
  @ViewChild('userModalForm',                 { static: false }) userModalForm!                : UserModalFormComponent;
  @ViewChild('warningModalForm',              { static: false }) warningModalForm!             : WarningModalFormComponent;

  get formTitle                () { return "Compose" + (this.singleChannelLabel ? " " + this.singleChannelLabel : "")                         ; }
  get hideChannelPanel         () { return this.shownChannelCount<=1                                                                          ; }
  get noChannelShown           () { return !this.showChannelEmail && !this.showChannelInApp && !this.showChannelSms                           ; }
  get shownChannelCount        () { return (this.showChannelInApp ? 1 : 0) + (this.showChannelSms ? 1 : 0) + (this.showChannelEmail ? 1 : 0)  ; }
  get showEndDate              () { return this.composeForm?.controls["channelInApp"]?.value===true                                           ; }
  get showTwilioDisabledWarning() { return !this.twilioEnabled && (this.showChannelSms || this.noChannelShown)                                ; }
  get smsAllowanceCompanyId    () { return this.smsAllowanceFromSenderCompany ? this.curUser.companyId : Math.abs(this.initialCompanyId)      ; }
  get smsCreditsPerRecipient   () { return Number(this.composeForm?.controls["smsProviderOverride"]?.value)===SmsProviderOverride.Both ? 2 : 1; }

  get canMessageBaseWide      () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCommunicationMessageBaseWide,         true); }
  get showSmsProviderOverride () { return this.componentAccessUserService.hasAccessGuid(AccessGuids.FormCommunicationShowSmsProviderOverride, true); }

  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }

  get showChannelEmail             () { return this.useTrmChannelParams
                                               ? this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowChannelEmailTrm,         true )
                                               : this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowChannelEmail,            true ); }
  get showChannelInApp             () { return this.useTrmChannelParams        
                                               ? this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowChannelInAppTrm,         false)
                                               : this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowChannelInApp,            true ); }
  get showChannelSms               () { return this.useTrmChannelParams        
                                               ? this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowChannelSmsTrm,           true )
                                               : this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowChannelSms,              true ); }
  get showTemplateSelector         () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationShowTemplateSelector,          true ); }
  get smsAllowanceFromSenderCompany() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormCommunicationSmsAllowanceFromSenderCompany, true ); }
  get supplierMessagingEnabled     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.CommunicationTemplatesUseSupplierMessaging,     false); }
  get twilioEnabled                () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.CommunicationSmsTwilioEnabled,                  true ); }

  get columnMinWidth() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.GridDefaultColumnMinWidth, 150); }

  get isSmsOnly(): boolean {
    return this.composeForm?.controls["channelSms"  ]?.value===true &&
           this.composeForm?.controls["channelInApp"]?.value!==true &&
           this.composeForm?.controls["channelEmail"]?.value!==true;
  }

  get noChannelSelected(): boolean {
    return this.composeForm?.controls["channelEmail"]?.value!==true &&
           this.composeForm?.controls["channelInApp"]?.value!==true &&
           this.composeForm?.controls["channelSms"  ]?.value!==true;
  }

  get singleChannelLabel(): string {
    if (this.noChannelShown)
      return "SMS";

    if (this.shownChannelCount===1) {
      if (this.showChannelInApp)
        return "In-App";

      if (this.showChannelSms  )
        return "SMS";

      if (this.showChannelEmail)
        return "Email";
    }

    return "";
  }

  get smsAllowanceExhausted(): boolean {
    const remaining=this.smsAllowance?.remainingMonthlyQuantity;

    return remaining!=undefined && remaining<=0;
  }

  get smsAllowanceShortfall(): number {
    const remaining=this.smsAllowance?.remainingMonthlyQuantity;

    if (remaining==undefined)
      return 0;

    return Math.max(0, this.smsCreditsRequired - remaining);
  }

  get smsAllowanceUsedPercent(): number {
    const total=this.smsAllowance?.totalMonthlyQuantity ?? 0;
    const used =this.smsAllowance?.usedMonthlyQuantity  ?? 0;

    if (total<=0)
      return 0;

    return Math.min(100, Math.round((used/total)*100));
  }

  get smsCreditsRequired(): number {
    if (this.composeForm?.controls["channelSms"]?.value!==true)
      return 0;

    return (this.selectedRecipients?.length ?? 0) * this.smsCreditsPerRecipient;
  }

  private closeAfterSend                   : boolean=true;
  private communicationComposeModalFormRef!: NgbModalRef;
  private companyDefaults!                 : CommunicationTemplatesDefaultsDTO;
  private gridSelectionBound               : boolean=false;
  private gridViewDefaults!                : GridViewDefaults;
  private initialUserSelected              : boolean=false;
  private inAppChannelId                   : number | undefined;
  private smsChannelId                     : number | undefined;
  private emailChannelId                   : number | undefined;
  private templateReplacements             : CommunicationTemplateReplacements[]=[];
  private userModalFormIsOpen              : boolean=false;

  private readonly scheduleLeadMinutes: number=15;

  public communicationTypeIdData!: IdAndDescriptionDTO[];
  public composeForm!            : UntypedFormGroup;
  public composeTemplates        : CommunicationTemplateDTO[]=[];
  public curUser                 : SystemUserDTO;
  public dgApiPath!              : DgApiPath | undefined;
  public dgActionColumn!         : DgActionColumn | undefined;
  public dgColumns!              : Array<DgColumn>;
  public dgPopup!                : DgPopup | undefined;
  public dgProperties!           : DgProperties | undefined;
  public emailChannelAvailable   : boolean=true;
  public emailChannelReason      : string="";
  public endDate                 : OurDate | undefined;
  public formSubmitted           : boolean=false;
  public gotDgProperties         : boolean=false;
  public inAppChannelAvailable   : boolean=true;
  public initialCompanyId        : number;
  public initialUserId           : number | undefined;
  public isSending               : boolean=false;
  public scheduleForLater        : boolean=false;
  public selectedRecipientCount  : number=0;
  public selectedRecipients      : any[]=[];
  public selectedTemplateId      : number | undefined;
  public smsAllowance            : WidgetSMSAllowanceDTO=WidgetSMSAllowanceDTO_EmptyObject();
  public smsChannelAvailable     : boolean=true;
  public smsChannelReason        : string="";
  public startDate               : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public templateButtonsEnabled  : boolean=false;
  public templateDropdownOpen    : boolean=false;

  public subjectMaxLength: number=200;

  public readonly smsOnlySubject     : string                    =_MustMatchServerStrings.SmsOnlyTemplateSubject;
  public readonly SmsProviderOverride: typeof SmsProviderOverride=SmsProviderOverride;

  constructor(
    private authenticationService     : AuthenticationService,
    private commConfigService         : CommConfigService,
    private communicationService      : CommunicationService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private datePipe                  : DatePipe,
    private dropdownService           : DropdownService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private lastPassKillerService     : LastPassKillerService,
    private modalService              : NgbModal,
    private typesCommunicationService : TypesCommunicationService,
    private usersService              : UsersService,
    private widgetService             : WidgetService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
    this.initialCompanyId=(this.dropdownService.trackerCompanyId || this.curUser.companyId);
  }

  public ngOnInit(): void {
    try {
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async openForm(companyId?: number, userId?: number): Promise<void> {
    try {
      await this.prepareCompose(companyId, userId);
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async openInline(companyId?: number, userId?: number): Promise<void> {
    try {
      this.inline=true;
      await this.prepareCompose(companyId, userId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async prepareCompose(companyId?: number, userId?: number): Promise<void> {
    try {
      this.resetMainVariables();

      this.initialUserId=(userId != undefined && userId>0) ? userId : undefined;

      if (companyId != undefined && companyId != 0)
        this.initialCompanyId=companyId;

      this.gotDgProperties=false;
      await this.setUpDgApiPaths();
      this.gotDgProperties=true;

      this.loadComposeTemplates();
      this.refreshCommunicationTypeData();
      this.refreshDeliveryTypeData();
      this.refreshSmsAllowance();
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resetMainVariables(): void {
    try {
      this.closeAfterSend        =true;
      this.composeTemplates      =[];
      this.emailChannelAvailable =true;
      this.emailChannelReason    ="";
      this.endDate               =undefined;
      this.formSubmitted         =false;
      this.gridSelectionBound    =false;
      this.inAppChannelAvailable =true;
      this.initialCompanyId      =(this.dropdownService.trackerCompanyId || this.curUser.companyId);
      this.initialUserId         =undefined;
      this.initialUserSelected   =false;
      this.isSending             =false;
      this.scheduleForLater      =false;
      this.selectedRecipientCount=0;
      this.selectedRecipients    =[];
      this.selectedTemplateId    =undefined;
      this.smsAllowance          =WidgetSMSAllowanceDTO_EmptyObject();
      this.smsChannelAvailable   =true;
      this.smsChannelReason      ="";
      this.startDate             =populateOurDate(this.exceptionsService, Date.now());
      this.templateButtonsEnabled=false;
      this.templateDropdownOpen  =false;
      this.userModalFormIsOpen   =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.refreshGet=() => this.setUpDgApiPathGet();

      await this.setUpDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPathGet(): Promise<void> {
    try {
      const encResult     =await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>this.initialCompanyId, true));
      const companyIdEncSS=encResult.result;

      this.dgApiPath!.get=apiPath + "?companyIdEncSS=" + companyIdEncSS + "&excludeIotDevices=true";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn(): void {
    try {
      this.dgActionColumn               =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting=false;
      this.dgActionColumn!.allowUpdating=false;
      this.dgActionColumn!.visible      =false;
      this.dgActionColumn!.width        =DgActionColumnWidth.oneButtonWithLeftRightPadding;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup(): void {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties(): void {
    try {
      this.dgProperties                      =this.gridViewDefaults.setUpDgProperties("Recipients", exportFilenameSuffix + "-" + this.curUser.companyId);
      this.dgProperties!.checkbox0           =this.gridViewDefaults.setUpDgCheckbox("Horizontal Scroll & Fixed Columns",
                                                                                    true,
                                                                                    false,
                                                                                    false,
                                                                                    this.columnMinWidth>0);
      this.dgProperties!.columnHidingEnabled =true;
      this.dgProperties!.columnMinWidth      =undefined;
      this.dgProperties!.gridKey             ="CommunicationComposeModalForm";
      this.dgProperties!.height              ="100%";
      this.dgProperties!.pageSize            =10;
      this.dgProperties!.selectionMode       =DgSelectionMode.multiple;
      this.dgProperties!.selectionCheckBoxMode=DgSelectionCheckBoxMode.always;
      this.dgProperties!.showAddButton       =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns(): void {
    try {
      let dgColumn: DgColumn | undefined;

      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.formVisible=false;
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //Company
      dgColumn             =this.gridViewDefaults.setUpDgColumn("companyName", "Company", "", DgColumnDataType.string);
      dgColumn!.gridVisible=this.showCompanyColumn();
      this.dgColumns.push(dgColumn!);

      //Fullname
      dgColumn                   =this.gridViewDefaults.setUpDgColumn("fullname", "User", "", DgColumnDataType.string);
      dgColumn!.avatarClickable  =true;
      dgColumn!.cellTemplate     ="RecipientUserTemplate";
      dgColumn!.cellTemplateType ="avatar";
      this.dgColumns.push(dgColumn!);

      //Email
      dgColumn             =this.gridViewDefaults.setUpDgColumn("email", "Email", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      dgColumn!.width      =DgColumnWidths.email;
      this.dgColumns.push(dgColumn!);

      //Mobile
      dgColumn             =this.gridViewDefaults.setUpDgColumnMobile("mobile", "Mobile");
      dgColumn!.gridVisible=false;
      this.dgColumns.push(dgColumn!);

      //LastCountryFlagIcon
      dgColumn                     =this.gridViewDefaults.setUpDgColumn("lastCountryFlagIcon", "Last Country", "", DgColumnDataType.string);
      dgColumn!.allowSearch        =false;
      dgColumn!.gridVisible        =false;
      dgColumn!.showInColumnChooser=false;
      this.dgColumns.push(dgColumn!);

      //LastCountry
      dgColumn                  =this.gridViewDefaults.setUpDgColumn("lastCountry", "Last Country", "", DgColumnDataType.string);
      dgColumn!.cellTemplate    ="LastCountryTemplate";
      dgColumn!.cellTemplateType="imageAndValue";
      dgColumn!.imageColumn     ="lastCountryFlagIcon";
      dgColumn!.width           =152;
      this.dgColumns.push(dgColumn!);

      //ICCID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("iccid", "ICCID", "", DgColumnDataType.string);
      dgColumn!.gridVisible=false;
      dgColumn!.width      =DgColumnWidths.iccic;
      this.dgColumns.push(dgColumn!);

      //SIMStatus
      dgColumn       =this.gridViewDefaults.setUpDgColumn("simStatus", "SIM Status", "", DgColumnDataType.string);
      dgColumn!.width=DgColumnWidths.simStatus;
      this.dgColumns.push(dgColumn!);

      dgColumn               =this.gridViewDefaults.setUpDgColumn("lastUsage", "Last Active", null, DgColumnDataType.datetime);
      dgColumn!.customizeText=(args: any) => {
        return args.value ? this.datePipe.transform(new Date(args.value), 'dd/MM/yyyy HH:mm') : "";
      };
      dgColumn!.width        =150;
      this.dgColumns.push(dgColumn!);

      this.assignColumnVisibleIndexes();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private assignColumnVisibleIndexes(): void {
    try {
      let index=0;

      for (const column of (this.dgColumns ?? [])) {
        column.visibleIndex=index++;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.communicationComposeModalFormRef=this.modalService.open(this.communicationComposeModalForm, { backdrop   : this.modalBackGround,
                                                                                                         centered   : true,
                                                                                                         keyboard   : false,
                                                                                                         size       : msSize.FullScreen,
                                                                                                         windowClass: "compose-modal-wide" });
    }
    catch(e) {
      this.formCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region composeForm

  get formOfCompose() {
    return this.composeForm.controls;
  }

  private setUpForm(): void {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm(): void {
    try {
      this.removeFormFields(this.composeForm);

      this.composeForm=this.formBuilder.group({ });

      this.addFormFields(this.composeForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormFields(formGroup: UntypedFormGroup): void {
    try {
      if (formGroup==this.composeForm) {
        this.addFormControl(formGroup, "active",              true,                        []);
        this.addFormControl(formGroup, "channelEmail",        false,                       []);
        this.addFormControl(formGroup, "channelInApp",        !this.noChannelShown,        []);
        this.addFormControl(formGroup, "channelSms",          this.noChannelShown,         []);
        this.addFormControl(formGroup, "communicationTypeId", undefined,                   [Validators.required]);
        this.addFormControl(formGroup, "endDate",             undefined,                   []);
        this.addFormControl(formGroup, "message",             undefined,                   [Validators.required]);
        this.addFormControl(formGroup, "scheduleForLater",    false,                       []);
        this.addFormControl(formGroup, "smsProviderOverride", SmsProviderOverride.Default, []);
        this.addFormControl(formGroup, "startDate",           this.startDate?.date,        [Validators.required]);
        this.addFormControl(formGroup, "subject",             undefined,                   [Validators.required, Validators.maxLength(this.subjectMaxLength)]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | Date | number | string | undefined,
                         validators: Validators): void {
    try {
      form.addControl(dataField, new FormControl(value, validators));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private removeFormFields(form: UntypedFormGroup): void {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public composeFormCancel(): void {
    try {
      this.formCancelled.emit();

      if (!this.inline)
        this.communicationComposeModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public composeFormSubmit(closeAfter: boolean=true): void {
    try {
      if (this.isSending)
        return;

      this.closeAfterSend=closeAfter;
      this.formSubmitted =true;

      if (this.selectedRecipientCount<=0) {
        this.warningModalForm.openForm("No recipients selected", "Please select at least one recipient.");
        return;
      }

      if (!this.atLeastOneChannelTicked()) {
        this.warningModalForm.openForm("No channels selected", "Please select at least one delivery channel.");
        return;
      }

      if (this.scheduleForLater && !this.scheduledDateIsInFuture()) {
        this.warningModalForm.openForm("Invalid schedule", "Please choose a send date and time in the future. Times are UTC.");
        return;
      }

      if (this.composeForm.valid) {
        this.prepareAndSendCompose();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dates & dropdown data

  public startDateChanged(startDate: OurDate): void {
    try {
      this.startDate=startDate;

      this.composeForm.controls["startDate"].setValue(this.startDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private clearEndDateIfNotInApp(): void {
    try {
      if (this.showEndDate)
        return;

      this.endDate=undefined;

      this.composeForm?.controls["endDate"]?.setValue(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public endDateChanged(endDate: OurDate): void {
    try {
      this.endDate=endDate;

      this.composeForm.controls["endDate"].setValue(this.endDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public scheduleForLaterChanged(scheduleForLater: boolean): void {
    try {
      this.scheduleForLater=scheduleForLater;
      this.startDate       =populateOurDate(this.exceptionsService,
                                            scheduleForLater ? Date.now()+this.scheduleLeadMinutes*60000
                                                             : Date.now());

      this.composeForm.controls["startDate"].setValue(this.startDate?.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private scheduledDateIsInFuture(): boolean {
    try {
      const startDate=this.composeForm.controls["startDate"].value;

      if (startDate==undefined)
        return false;

      return new Date(startDate).getTime() > Date.now();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public getDropdownDataObjectArray(fieldName: string): IdAndDescriptionDTO[] | undefined {
    try {
      if (fieldName=="communicationTypeId") {
        return this.communicationTypeIdData;
      }

      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string): void {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="communicationTypeId") {
              this.communicationTypeIdData=(data as IdAndDescriptionDTO[]);
              
              this.applySmsOnlyFieldState();
            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCommunicationTypeData(): void {
    try {
      this.getDropdownData(this.typesCommunicationService.getIdAndDescription(), "communicationTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Channel availability

  private refreshDeliveryTypeData(): void {
    try {
      this.emailChannelId=DeliveryType.Email;
      this.inAppChannelId=DeliveryType.InApp;
      this.smsChannelId  =DeliveryType.SMS;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshSmsAllowance(): void {
    try {
      const now=new Date();

      this.widgetService.getCompanySMSAllowance(this.curUser.userId, this.smsAllowanceCompanyId, now.getFullYear(), now.getMonth() + 1, now.getDate())
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.smsAllowance=data ?? WidgetSMSAllowanceDTO_EmptyObject();
          
          this.applySmsChannelAvailability();
          this.applyChannelEnabledState();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCheckboxChange(value: boolean | number | string): void {
    try {
      const on=value===true;

      this.dgProperties!.checkbox0!.value   =value;
      this.dgProperties!.columnHidingEnabled=!on;
      this.dgProperties!.columnMinWidth     =on ? this.columnMinWidth : undefined;

      this.recipientsGrid.setColumnHidingEnabled(!on);
      this.recipientsGrid.setColumnMinWidth(this.dgProperties!.columnMinWidth, this.dgActionColumn!.width);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onGridContentReady(): void {
    try {
      if (!this.gridSelectionBound) {
        this.gridSelectionBound=true;
        
        this.applyCompanyColumnVisibility();
        this.recipientsGrid.dataGrid.instance.option('selectAllMode', 'allPages');
        
        setTimeout(() => this.recipientsGrid.dataGrid.instance.updateDimensions(), 0);

        this.recipientsGrid.dataGrid.instance.on('selectionChanged', (event: any) => {
          this.onGridSelectionChanged(event.selectedRowsData);
        });
      }

      this.applyInitialUserSelection();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyInitialUserSelection(): void {
    try {
      if (this.initialUserId==undefined || this.initialUserSelected)
        return;

      const instance=this.recipientsGrid?.dataGrid?.instance;

      if (instance==undefined)
        return;

      const items: any[]=this.recipientsGrid?.clientSideProcessingModels ?? [];
      const rowLoaded   =items.some((row: any) => row?.id===this.initialUserId);

      if (!rowLoaded)
        return;

      this.initialUserSelected=true;
      instance.selectRows([this.initialUserId], true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private reapplySelectionForCurrentGrid(): void {
    try {
      const instance=this.recipientsGrid?.dataGrid?.instance;

      if (instance==undefined)
        return;

      const currentGridIds=new Set((this.recipientsGrid?.clientSideProcessingModels ?? []).map((row: any) => row.id));
      const idsToReselect =this.selectedRecipients.filter(row => currentGridIds.has(row.id)).map(row => row.id);

      if (idsToReselect.length>0)
        instance.selectRows(idsToReselect, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private onGridSelectionChanged(selectedRows: any[]): void {
    try {
      const currentGridIds=new Set((this.recipientsGrid?.clientSideProcessingModels ?? []).map((row: any) => row.id));
      const preserved     =this.selectedRecipients.filter(row => !currentGridIds.has(row.id));
      const merged        =[...preserved, ...(selectedRows ?? [])];
      const selectedIds   =merged.map(row => row.id);

      this.selectedRecipientCount=selectedIds.length;
      this.selectedRecipients    =this.sortRecipientsByLabel(merged);

      if (selectedIds.length===0) {
        this.emailChannelAvailable=true;
        this.emailChannelReason   ="";
        this.inAppChannelAvailable=true;
        this.applySmsChannelAvailability();
        this.applyChannelEnabledState();
        return;
      }

      let recipientsWithoutEmail=0;

      for (const row of this.selectedRecipients) {
        if (!this.recipientHasEmail(row))
          recipientsWithoutEmail++;
      }

      this.inAppChannelAvailable=true;
      this.emailChannelAvailable=recipientsWithoutEmail===0;
      this.emailChannelReason   =recipientsWithoutEmail>0 ? `${recipientsWithoutEmail} of ${selectedIds.length} recipients have no email address` : "";

      this.applySmsChannelAvailability();
      this.applyChannelEnabledState();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applySmsChannelAvailability(): void {
    try {
      if (this.smsAllowanceExhausted) {
        this.smsChannelAvailable=false;
        this.smsChannelReason   ="This company has no SMS allowance remaining this month.";
        return;
      }

      const selectedRecipients  =this.selectedRecipients ?? [];
      let   recipientsWithoutSms=0;

      for (const row of selectedRecipients) {
        if (!this.recipientHasMobile(row))
          recipientsWithoutSms++;
      }

      this.smsChannelAvailable=recipientsWithoutSms===0;
      this.smsChannelReason   =recipientsWithoutSms>0 ? `${recipientsWithoutSms} of ${selectedRecipients.length} recipients have no mobile number` : "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private recipientHasEmail(recipient: any): boolean {
    try {
      return (recipient?.email ?? "").toString().trim() !== "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private recipientHasMobile(recipient: any): boolean {
    try {
      return (recipient?.mobile ?? "").toString().trim() !== "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private lockSingleChannel(control: AbstractControl | undefined): void {
    try {
      control?.setValue(true, { emitEvent: false });
      control?.disable (      { emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyChannelEnabledState(): void {
    try {
      if (this.composeForm==undefined)
        return;

      const emailCtrl=this.composeForm.controls["channelEmail"];
      const inAppCtrl=this.composeForm.controls["channelInApp"];
      const smsCtrl  =this.composeForm.controls["channelSms"  ];

      const emailEnabled=this.showChannelEmail && this.emailChannelAvailable;
      const inAppEnabled=this.showChannelInApp && this.inAppChannelAvailable;
      const smsEnabled  =(this.showChannelSms  || this.noChannelShown) && this.smsChannelAvailable;

      if (emailEnabled)
        emailCtrl?.enable({ emitEvent: false });
      else {
        emailCtrl?.setValue(false, { emitEvent: false });
        emailCtrl?.disable({ emitEvent: false });
      }

      if (inAppEnabled)
        inAppCtrl?.enable({ emitEvent: false });
      else {
        inAppCtrl?.setValue(false, { emitEvent: false });
        inAppCtrl?.disable({ emitEvent: false });
      }

      if (smsEnabled) {
        smsCtrl?.enable({ emitEvent: false });

        if (this.noChannelShown)
          smsCtrl?.setValue(true, { emitEvent: false });
      }
      else {
        smsCtrl?.setValue(false, { emitEvent: false });
        smsCtrl?.disable({ emitEvent: false });
      }

      if (this.shownChannelCount===1) {
        if (this.showChannelEmail && emailEnabled)
          this.lockSingleChannel(emailCtrl);

        if (this.showChannelInApp && inAppEnabled)
          this.lockSingleChannel(inAppCtrl);

        if (this.showChannelSms && smsEnabled)
          this.lockSingleChannel(smsCtrl);
      }

      this.applySmsOnlyFieldState();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onChannelToggled(): void {
    try {
      this.applySmsOnlyFieldState();
      this.clearEndDateIfNotInApp();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applySmsOnlyFieldState(): void {
    try {
      const subjectCtrl=this.composeForm?.controls["subject"];
      const typeCtrl   =this.composeForm?.controls["communicationTypeId"];

      if (subjectCtrl==undefined || typeCtrl==undefined)
        return;

      if (this.isSmsOnly) {
        subjectCtrl.clearValidators();
        subjectCtrl.setValue(undefined, { emitEvent: false });

        typeCtrl.clearValidators();
        typeCtrl.setValue(this.messageCommunicationTypeId(), { emitEvent: false });
      }
      else {
        subjectCtrl.setValidators([Validators.required, Validators.maxLength(this.subjectMaxLength)]);
        typeCtrl.setValidators([Validators.required]);
      }

      subjectCtrl.updateValueAndValidity({ emitEvent: false });
      typeCtrl.updateValueAndValidity({ emitEvent: false });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private messageCommunicationTypeId(): number | undefined {
    try {
      const match=(this.communicationTypeIdData ?? []).find(t => (t.description ?? "").trim().toLowerCase()=="message");

      return match?.id==undefined ? undefined : Number(match.id);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private showCompanyColumn(): boolean {
    try {
      return this.initialCompanyId<0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private applyCompanyColumnVisibility(): void {
    try {
      this.recipientsGrid?.dataGrid?.instance?.columnOption("companyName", "visible", this.showCompanyColumn());
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private atLeastOneChannelTicked(): boolean {
    try {
      return this.composeForm.controls["channelEmail"].value===true ||
             this.composeForm.controls["channelInApp"].value===true ||
             this.composeForm.controls["channelSms"  ].value===true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  //#endregion

  //#region Recipient chips

  private sortRecipientsByLabel(recipients: any[]): any[] {
    try {
      return [...recipients].sort((a, b) => this.recipientFullName(a).localeCompare(this.recipientFullName(b)));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return recipients;
    }
  }

  public recipientFullName(recipient: any): string {
    try {
      const fullName=(recipient?.fullname ?? `${recipient?.firstname ?? ""} ${recipient?.lastname ?? ""}`).trim();

      return fullName !== "" ? fullName : (recipient?.email ?? "Recipient");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "Recipient";
    }
  }

  public removeRecipient(recipient: any): void {
    try {
      const recipientId=recipient?.id;

      const currentGridIds=new Set((this.recipientsGrid?.clientSideProcessingModels ?? []).map((row: any) => row.id));

      if (currentGridIds.has(recipientId)) {
        this.recipientsGrid.dataGrid.instance.deselectRows([recipientId]);
        return;
      }

      this.selectedRecipients    =this.selectedRecipients.filter(row => row.id !== recipientId);
      this.selectedRecipientCount=this.selectedRecipients.length;
      this.applySmsChannelAvailability();
      this.applyChannelEnabledState();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public clearAllRecipients(): void {
    try {
      this.selectedRecipients    =[];
      this.selectedRecipientCount=0;
      this.recipientsGrid.dataGrid.instance.clearSelection();
      this.onGridSelectionChanged([]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Recipient user modal

  public onRecipientCellClick(e: any): void {
    try {
      const sureSimUserId: number | undefined=e?.data?.id;

      if (sureSimUserId==undefined || sureSimUserId<=0)
        return;

      if (this.userModalFormIsOpen)
        return;

      this.userModalFormIsOpen=true;
      this.userModalForm.openForm(sureSimUserId, eUser.sim);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public recipientUserDataHasBeenSaved(sureSimUserId: number | undefined): void {
    try {
      this.userModalFormIsOpen=false;

      this.refreshRecipientsGrid();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public recipientUserFormCancelled(): void {
    try {
      this.userModalFormIsOpen=false;

      this.refreshRecipientsGrid();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private refreshRecipientsGrid(): void {
    try {
      const selectedIds=(this.recipientsGrid?.dataGrid?.instance?.getSelectedRowKeys() ?? []);

      this.usersService.getUsersForCompanyIncAssociates(this.initialCompanyId, true)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.recipientsGrid.clientSideProcessingModels=data;
          this.recipientsGrid.dataGrid.instance.refresh();
          this.recipientsGrid.dataGrid.instance.selectRows(selectedIds, false);
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Company filter

  public companyDropDownOnChange(companyId: number): void {
    try {
      if (companyId===this.initialCompanyId)
        return;

      this.dropdownService.trackerCompanyId=companyId;
      this.initialCompanyId                =companyId;

      this.companyChanged.emit(companyId);

      this.usersService.getUsersForCompanyIncAssociates(companyId, true)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.recipientsGrid.clientSideProcessingModels=data;
          this.applyCompanyColumnVisibility();
          this.recipientsGrid.dataGrid.instance.refresh();

          this.reapplySelectionForCurrentGrid();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });

      this.refreshSmsAllowance();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Templates

  private applySelectedTemplateToForm(): void {
    try {
      if (this.selectedTemplateId==undefined || this.composeForm==undefined)
        return;

      const template=this.composeTemplates.find(t => t.id===this.selectedTemplateId);

      if (template==undefined)
        return;

      if (!this.isSmsOnly)
        this.composeForm.controls["subject"].setValue(template.subject==this.smsOnlySubject ? undefined : template.subject);

      this.composeForm.controls["message"].setValue(template.body);

      if (template.communicationTypeId != undefined)
        this.composeForm.controls["communicationTypeId"].setValue(template.communicationTypeId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public canEditTemplate(): boolean {
    try {
      return this.templateButtonsEnabled && ((this.selectedTemplateId ?? 0)>0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  public composeTemplateModalFormClosed(event: { TemplateModalAction: TemplateModalAction, TemplateId: number }): void {
    try {
      this.templateButtonsEnabled=false;

      if (event.TemplateModalAction==TemplateModalAction.Save || event.TemplateModalAction==TemplateModalAction.SaveAndEnable) {
        this.selectedTemplateId=event.TemplateId;

        this.loadComposeTemplates();
      }
      else {
        this.templateButtonsEnabled=true;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadComposeTemplates(): void {
    try {
      const templateCompanyId=this.curUser.companyId;

      forkJoin({
        templates   : this.commConfigService.getCommunicationTemplates(-Math.abs(templateCompanyId), MessageType.CommunicationComposeTemplate),
        defaults    : this.commConfigService.getCompanyCommunicationTemplatesDefaults(Math.abs(templateCompanyId)),
        replacements: this.commConfigService.getCommunicationTemplateReplacements(this.curUser.userId, MessageType.CommunicationComposeTemplate)
      })
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: ({ templates, defaults, replacements }) => {
          this.composeTemplates      =templates ?? [];
          this.companyDefaults       =JSON.parse(JSON.stringify(defaults ?? {}));
          this.templateReplacements  =replacements ?? [];
          this.templateButtonsEnabled=true;

          this.applySelectedTemplateToForm();
        },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onTemplateChange(): void {
    try {
      if (this.selectedTemplateId==undefined)
        return;

      this.applySelectedTemplateToForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openComposeTemplate(newTemplate: boolean): void {
    try {
      this.templateDropdownOpen=false;

      let template: CommunicationTemplateDTO | undefined;

      if (!newTemplate && this.selectedTemplateId != undefined) {
        template=this.composeTemplates.find(t => t.id===this.selectedTemplateId);
      }
      else {
        template={
          bcc                 : null,
          body                : null,
          cc                  : null,
          communicationTypeId : undefined,
          fromEmail           : null,
          fromNumber          : null,
          id                  : 0,
          messageTypeId       : MessageType.CommunicationComposeTemplate,
          name                : null,
          sendToUser          : true,
          sentElsewhere       : false,
          subject             : null,
          toEmail             : null,
          toNumber            : null,
          useDefaultBCC       : false,
          useDefaultCC        : false,
          useDefaultFromEmail : false,
          useDefaultFromNumber: false,
          useDefaultToEmail   : false,
          useDefaultToNumber  : false,
        } as unknown as CommunicationTemplateDTO;
      }

      if (template==undefined)
        return;

      this.emailTemplateModalForm.hideSubject=this.isSmsOnly;

      this.emailTemplateModalForm.openForm(
        MessageTypeText.CommunicationComposeTemplate,
        JSON.parse(JSON.stringify(template)),
        Math.abs(this.initialCompanyId),
        this.templateReplacements,
        this.companyDefaults,
        (template.id as number)>0,
        false,
        true,
        true,
        false,
        true,
        this.communicationTypeIdData
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleTemplateDropdown(): void {
    try {
      this.templateDropdownOpen=!this.templateDropdownOpen;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  @HostListener('document:click', ['$event'])
  public onDocumentClick(event: MouseEvent): void {
    try {
      if (!this.templateDropdownOpen)
        return;

      if (!this.templateDropdown?.nativeElement?.contains(<Node>event.target))
        this.templateDropdownOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Compose

  private smsProviderOverrideToSend(): number {
    try {
      if (!this.showSmsProviderOverride)
        return SmsProviderOverride.Default;

      if (this.composeForm.controls["channelSms"].value!==true)
        return SmsProviderOverride.Default;

      const override=Number(this.composeForm.controls["smsProviderOverride"].value) || SmsProviderOverride.Default;

      if (!this.twilioEnabled && (override===SmsProviderOverride.Twilio || override===SmsProviderOverride.Both))
        return SmsProviderOverride.Default;

      return override;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return SmsProviderOverride.Default;
    }
  }

  private recipientLimitResult(error: any): CommunicationComposeLimitResultDTO | undefined {
    try {
      const body=error?.error;

      if (error?.status!==400 || body==undefined)
        return undefined;

      const parsed=typeof body==='string' ? JSON.parse(body) : body;

      if (parsed?.error!==ErrorStrings.RecipientLimitExceeded)
        return undefined;

      return <CommunicationComposeLimitResultDTO>parsed;
    }
    catch(e) {
      return undefined;
    }
  }

  private showRecipientLimitMessage(limitResult: CommunicationComposeLimitResultDTO): void {
    try {
      const limit    =limitResult?.limit;
      const submitted=limitResult?.submitted;
      let   message  =limitResult?.message ?? "";

      if (message.length===0) {
        message=(submitted!=undefined ? "You selected " + submitted + " recipients, but a single " : "A single ") +
                "message can be sent to a maximum of " +
                (limit!=undefined ? limit : "the configured limit") +
                ". Please reduce your selection and try again.";
      }

      this.completedModalForm.openForm("Too Many Recipients", message);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private prepareAndSendCompose(): void {
    try {
      const selectedIds=this.selectedRecipients.map((row: any) => row.id);
      const channelIDs : number[]=[];

      if (this.composeForm.controls["channelInApp"].value===true && this.inAppChannelId != undefined)
        channelIDs.push(this.inAppChannelId);
      if (this.composeForm.controls["channelSms"].value===true && this.smsChannelId != undefined)
        channelIDs.push(this.smsChannelId);
      if (this.composeForm.controls["channelEmail"].value===true && this.emailChannelId != undefined)
        channelIDs.push(this.emailChannelId);

      const communication: CommunicationDTO={
        active             : this.composeForm.controls["active"].value,
        communicationTypeID: this.composeForm.controls["communicationTypeId"].value,
        companyID          : <number><unknown>null,
        endDate            : this.composeForm.controls["endDate"].value,
        enteredBy          : this.curUser.userId,
        id                 : 0,
        message            : this.composeForm.controls["message"].value,
        startDate          : this.composeForm.controls["startDate"].value,
        subject            : this.isSmsOnly ? undefined : this.composeForm.controls["subject"].value,
        userID             : <number><unknown>null
      };

      const composition: CommunicationCompositionDTO={
        channelIDs         : channelIDs,
        communication      : communication,
        recipientUserIDs   : selectedIds,
        smsProviderOverride: this.smsProviderOverrideToSend()
      };

      this.isSending=true;

      this.communicationService.compose(composition)
      .pipe(
        catchError((error) => {
          const limitResult=this.recipientLimitResult(error);

          if (limitResult!=undefined) {
            this.isSending=false;
            this.showRecipientLimitMessage(limitResult);

            return EMPTY;
          }

          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.isSending=false;
          this.processCompleteWithOutcome(data);
          this.dataHasBeenSaved.emit(data?.communicationID);
        },
        error: error => {
          this.isSending=false;

          if (String(error ?? "").includes(ErrorStrings.AllRecipientsCeased)) {
            this.completedModalForm.openForm("Nothing Sent", "All of the selected recipients belong to ceased companies, so nothing was sent.");
            return;
          }

          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Outcome summary

  private processCompleteWithOutcome(result: CommunicationCompositionResultDTO | undefined): void {
    try {
      const deliveries=result?.deliveries ?? [];

      if (deliveries.length===0) {
        this.completedModalForm.openForm("Communication Sent", "");
        return;
      }

      const inAppDeliveries=deliveries.filter(d => d.channelID===this.inAppChannelId);
      const smsDeliveries  =deliveries.filter(d => d.channelID===this.smsChannelId  );
      const emailDeliveries=deliveries.filter(d => d.channelID===this.emailChannelId);

      const lines: string[]=[];

      if (inAppDeliveries.length>0) lines.push(this.outcomeLineFor("In-App", inAppDeliveries));
      if (smsDeliveries  .length>0) lines.push(this.outcomeLineFor("SMS",    smsDeliveries  ));
      if (emailDeliveries.length>0) lines.push(this.outcomeLineFor("Email",  emailDeliveries));

      const subMessage=lines.join("<br/>");

      this.completedModalForm.openForm("Communication Sent", subMessage);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private outcomeLineFor(channelLabel: string, deliveries: CommunicationDeliveryOutcomeDTO[]): string {
    try {
      const total =deliveries.length;
      const failed=deliveries.filter(d => !!d.lastError);
      const ok    =total - failed.length;

      let line=`<strong>${channelLabel}:</strong> ${ok} of ${total} `;

      if (channelLabel==="In-App")
        line += "sent";
      else
        line += (failed.length===0 ? "queued for sending" : "queued, " + failed.length + " failed");

      if (failed.length>0) {
        const firstReason=failed[0].lastError ?? "Unknown failure";
        line += ` <span style="color:${OurColors.Red}">(${firstReason})</span>`;
      }

      return line;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return channelLabel;
    }
  }

  public completedModalHasBeenClosed(): void {
    try {
      if (this.closeAfterSend && !this.inline) {
        this.communicationComposeModalFormRef.close();
        this.dataHasBeenSaved.emit(undefined);
      }
      else {
        this.resetForAnotherMessage();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resetForAnotherMessage(): void {
    try {
      this.formSubmitted=false;

      this.clearAllRecipients();

      this.composeForm.controls["message"].setValue(undefined);
      this.composeForm.controls["smsProviderOverride"].setValue(SmsProviderOverride.Default);

      if (!this.isSmsOnly) {
        this.composeForm.controls["subject"].setValue(undefined);
        this.composeForm.controls["communicationTypeId"].setValue(undefined);
      }

      this.selectedTemplateId=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
